// extracted by mini-css-extract-plugin
export var form = "subscribe-first-module--form--b1640";
export var formState = "subscribe-first-module--formState--dd83e";
export var showMobile = "subscribe-first-module--showMobile--c09d0";
export var smallLink = "subscribe-first-module--smallLink--7b731";
export var spin = "subscribe-first-module--spin--4dcfb";